import util from '@bmp-vue/core/api/util'

const controller = 'Home'

export default Object.assign({}, util.GetCrud(controller, null), {

})
